/**
 * Input form component for collecting user data
 */

import { getCountries } from '../data/lifeExpectancy';

export interface FormData {
  birthDate: Date;
  countryCode: string;
  gender: 'male' | 'female' | 'other';
  customExpectancy: number | null;
}

export function createInputForm(
  onSubmit: (data: FormData) => void
): HTMLElement {
  const page = document.createElement('div');
  page.className = 'input-page fade-in';

  const card = document.createElement('div');
  card.className = 'input-card glass-card';

  // Header
  const header = document.createElement('div');
  header.className = 'input-header';
  header.innerHTML = `
    <h1>Finite</h1>
    <p class="tagline">Every week is a gift. What will you do with yours?</p>
  `;

  // Form
  const form = document.createElement('form');
  form.className = 'input-form';
  form.innerHTML = `
    <div class="form-group">
      <label class="form-label" for="birthDate">When were you born?</label>
      <input
        type="date"
        id="birthDate"
        class="form-input"
        required
        max="${new Date().toISOString().split('T')[0]}"
      />
    </div>

    <div class="form-group">
      <label class="form-label" for="country">Where do you live?</label>
      <select id="country" class="form-select" required>
        <option value="">Select your country</option>
        ${getCountries().map(c =>
    `<option value="${c.code}">${c.name}</option>`
  ).join('')}
      </select>
    </div>
    
    <div class="form-group">
      <label class="form-label">What's your gender?</label>
      <div class="radio-group">
        <div class="radio-option">
          <input type="radio" id="male" name="gender" value="male" required />
          <label for="male">Male</label>
        </div>
        <div class="radio-option">
          <input type="radio" id="female" name="gender" value="female" />
          <label for="female">Female</label>
        </div>
        <div class="radio-option">
          <input type="radio" id="other" name="gender" value="other" />
          <label for="other">Other</label>
        </div>
      </div>
    </div>
    
    <div class="form-group">
      <label class="form-label" for="customExpectancy">
        Custom life expectancy (optional)
      </label>
      <input 
        type="number" 
        id="customExpectancy" 
        class="form-input" 
        placeholder="Leave blank to use country average"
        min="1"
        max="150"
      />
      <span class="form-hint">Override the statistical average with your own estimate</span>
    </div>
    
    <button type="submit" class="btn btn-primary">
      Visualize my life
    </button>

    <p class="privacy-disclaimer">
      Your information stays on your device. We don't collect or store any data you enter.
    </p>
  `;

  // Handle form submission
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const birthDateInput = form.querySelector('#birthDate') as HTMLInputElement;
    const countrySelect = form.querySelector('#country') as HTMLSelectElement;
    const genderRadio = form.querySelector('input[name="gender"]:checked') as HTMLInputElement;
    const customInput = form.querySelector('#customExpectancy') as HTMLInputElement;

    if (!birthDateInput.value || !countrySelect.value || !genderRadio) {
      return;
    }

    const data: FormData = {
      birthDate: new Date(birthDateInput.value),
      countryCode: countrySelect.value,
      gender: genderRadio.value as 'male' | 'female' | 'other',
      customExpectancy: customInput.value ? parseFloat(customInput.value) : null,
    };

    onSubmit(data);
  });

  card.appendChild(header);
  card.appendChild(form);
  page.appendChild(card);

  return page;
}
